"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.patchOperations = exports.patchSubAccount = exports.patchAccount = exports.minimalOperationsBuilderSync = exports.minimalOperationsBuilder = void 0;
// libcore reconciliation by the React definition. https://reactjs.org/docs/reconciliation.html
// TODO move to account/
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var bignumber_js_1 = require("bignumber.js");
var jsHelpers_1 = require("./bridge/jsHelpers");
var account_1 = require("./account");
var consoleWarnExpectToEqual_1 = __importDefault(require("./consoleWarnExpectToEqual"));
// aim to build operations with the minimal diff & call to libcore possible
function minimalOperationsBuilder(existingOperations, coreOperations, buildOp, // if defined, allows to merge some consecutive operation that have same hash
mergeSameHashOps) {
    return __awaiter(this, void 0, void 0, function () {
        var state, operationWithSameHash, i, coreOperation, op, newOp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (existingOperations.length === 0 && coreOperations.length === 0) {
                        return [2 /*return*/, existingOperations];
                    }
                    state = {
                        finished: false,
                        operations: [],
                        existingOps: existingOperations || [],
                        immutableOpCmpDoneOnce: false
                    };
                    operationWithSameHash = [];
                    i = coreOperations.length - 1;
                    _a.label = 1;
                case 1:
                    if (!(i >= 0)) return [3 /*break*/, 4];
                    coreOperation = coreOperations[i];
                    return [4 /*yield*/, buildOp(coreOperation)];
                case 2:
                    op = _a.sent();
                    if (!op)
                        return [3 /*break*/, 3]; // some operation can be skipped by implementation
                    newOp = void 0;
                    if (mergeSameHashOps) {
                        if (operationWithSameHash.length === 0 ||
                            operationWithSameHash[0].hash === op.hash) {
                            // we accumulate consecutive op of same hash in operationWithSameHash
                            operationWithSameHash.push(op);
                            return [3 /*break*/, 3];
                        }
                        // when the new op no longer matches the one accumulated,
                        // we can "release" one operation resulting of merging the accumulation
                        newOp = mergeSameHashOps(operationWithSameHash);
                        operationWithSameHash = [op];
                    }
                    else {
                        // mergeSameHashOps not used = normal iteration
                        newOp = op;
                    }
                    stepBuilder(state, newOp, i);
                    if (state.finished) {
                        return [2 /*return*/, state.operations];
                    }
                    _a.label = 3;
                case 3:
                    i--;
                    return [3 /*break*/, 1];
                case 4:
                    if (mergeSameHashOps && operationWithSameHash.length) {
                        stepBuilder(state, mergeSameHashOps(operationWithSameHash), 0);
                    }
                    return [2 /*return*/, state.operations];
            }
        });
    });
}
exports.minimalOperationsBuilder = minimalOperationsBuilder;
function minimalOperationsBuilderSync(existingOperations, coreOperations, buildOp) {
    if (existingOperations.length === 0 && coreOperations.length === 0) {
        return existingOperations;
    }
    var state = {
        finished: false,
        operations: [],
        existingOps: existingOperations || [],
        immutableOpCmpDoneOnce: false
    };
    for (var i = coreOperations.length - 1; i >= 0; i--) {
        var coreOperation = coreOperations[i];
        var newOp = buildOp(coreOperation);
        if (!newOp)
            continue;
        stepBuilder(state, newOp, i);
        if (state.finished) {
            return state.operations;
        }
    }
    return state.operations;
}
exports.minimalOperationsBuilderSync = minimalOperationsBuilderSync;
var shouldRefreshBalanceHistoryCache = function (balanceHistoryCache, account) {
    var oldH = account.balanceHistoryCache.HOUR;
    var newH = balanceHistoryCache.HOUR;
    if (oldH.latestDate !== newH.latestDate)
        return true; // date have changed, need to refresh the array
    if (oldH.balances.length !== newH.balances.length)
        return true; // balances length changes (new ops for instance)
    var length = newH.balances.length;
    if (length === 0)
        return false;
    if (oldH.balances[length - 1] !== newH.balances[length - 1])
        return true; // latest datapoint changes.
    return false;
};
// FIXME DEPRECATED post portfolio v2
var shouldRefreshBalanceHistory = function (balanceHistory, account) {
    var week = balanceHistory.week;
    var accountWeek = account.balanceHistory && account.balanceHistory.week;
    if (!week || !accountWeek)
        return true; // there is no week yet || there were no balance history yet
    var _a = __read(week[0], 1), firstDate = _a[0];
    var _b = __read(week[week.length - 1], 2), lastValue = _b[1];
    var firstAccountDate = accountWeek[0].date;
    var lastAccountValue = accountWeek[accountWeek.length - 1].value;
    var isSameDate = firstDate === firstAccountDate.toISOString();
    return (!isSameDate || // start date of the range has changed
        lastValue !== lastAccountValue.toString() || // final balance has changed
        week.length !== accountWeek.length // number of endpoints has changed
    );
};
function shouldRefreshBitcoinResources(updatedRaw, account) {
    if (!updatedRaw.bitcoinResources)
        return false;
    if (!account.bitcoinResources)
        return true;
    if (updatedRaw.blockHeight !== account.blockHeight)
        return true;
    if (updatedRaw.operations.length !== account.operations.length)
        return true;
    var existing = account.bitcoinResources;
    var raw = updatedRaw.bitcoinResources;
    // FIXME Need more typing in wallet-btc to have a meaningful comparison
    //if (!isEqual(raw.walletAccount?.xpub?.data, existing.walletAccount?.xpub?.data)) return true;
    if (raw.utxos.length !== existing.utxos.length)
        return true;
    return !(0, isEqual_1["default"])(raw.utxos, existing.utxos);
}
function patchAccount(account, updatedRaw) {
    var _a;
    // id can change after a sync typically if changing the version or filling more info. in that case we consider all changes.
    if (account.id !== updatedRaw.id)
        return (0, account_1.fromAccountRaw)(updatedRaw);
    var subAccounts;
    if (updatedRaw.subAccounts) {
        var existingSubAccounts_1 = account.subAccounts || [];
        var subAccountsChanged_1 = updatedRaw.subAccounts.length !== existingSubAccounts_1.length;
        subAccounts = updatedRaw.subAccounts.map(function (ta) {
            var existing = existingSubAccounts_1.find(function (t) { return t.id === ta.id; });
            var patched = patchSubAccount(existing, ta);
            if (patched !== existing) {
                subAccountsChanged_1 = true;
            }
            return patched;
        });
        if (!subAccountsChanged_1) {
            subAccounts = existingSubAccounts_1;
        }
    }
    var operations = patchOperations(account.operations, updatedRaw.operations, updatedRaw.id, subAccounts);
    var pendingOperations = patchOperations(account.pendingOperations, updatedRaw.pendingOperations, updatedRaw.id, subAccounts);
    var next = __assign({}, account);
    var changed = false;
    if (subAccounts && account.subAccounts !== subAccounts) {
        next.subAccounts = subAccounts;
        changed = true;
    }
    if (account.operations !== operations) {
        next.operations = operations;
        changed = true;
    }
    if (account.operationsCount !== updatedRaw.operationsCount &&
        updatedRaw.operationsCount) {
        next.operationsCount = updatedRaw.operationsCount;
        changed = true;
    }
    if (account.pendingOperations !== pendingOperations) {
        next.pendingOperations = pendingOperations;
        changed = true;
    }
    if (updatedRaw.balance !== account.balance.toString()) {
        next.balance = new bignumber_js_1.BigNumber(updatedRaw.balance);
        changed = true;
    }
    // DEPRECATED post portfolio v2
    var balanceHistory = updatedRaw.balanceHistory;
    if (balanceHistory) {
        if (shouldRefreshBalanceHistory(balanceHistory, account)) {
            next.balanceHistory = (0, account_1.fromBalanceHistoryRawMap)(balanceHistory);
            changed = true;
        }
    }
    else if (next.balanceHistory) {
        delete next.balanceHistory;
        changed = true;
    }
    if (updatedRaw.spendableBalance !== account.spendableBalance.toString()) {
        next.spendableBalance = new bignumber_js_1.BigNumber(updatedRaw.spendableBalance || updatedRaw.balance);
        changed = true;
    }
    if (updatedRaw.lastSyncDate !== account.lastSyncDate.toISOString()) {
        next.lastSyncDate = new Date(updatedRaw.lastSyncDate);
        changed = true;
    }
    if (updatedRaw.creationDate &&
        updatedRaw.creationDate !== account.creationDate.toISOString()) {
        next.creationDate = new Date(updatedRaw.creationDate);
        changed = true;
    }
    if (account.freshAddress !== updatedRaw.freshAddress) {
        next.freshAddress = updatedRaw.freshAddress;
        changed = true;
    }
    if (account.freshAddressPath !== updatedRaw.freshAddressPath) {
        next.freshAddressPath = updatedRaw.freshAddressPath;
        changed = true;
    }
    if (account.blockHeight !== updatedRaw.blockHeight) {
        next.blockHeight = updatedRaw.blockHeight;
        changed = true;
    }
    if (account.syncHash !== updatedRaw.syncHash) {
        next.syncHash = updatedRaw.syncHash;
        changed = true;
    }
    var balanceHistoryCache = updatedRaw.balanceHistoryCache;
    if (balanceHistoryCache) {
        if (shouldRefreshBalanceHistoryCache(balanceHistoryCache, account)) {
            next.balanceHistoryCache = balanceHistoryCache;
            changed = true;
        }
    }
    if (updatedRaw.tronResources &&
        // @ts-expect-error check if this is valid for deep equal check
        account.tronResources !== updatedRaw.tronResources) {
        next.tronResources = (0, account_1.fromTronResourcesRaw)(updatedRaw.tronResources);
        changed = true;
    }
    if (updatedRaw.cosmosResources &&
        // @ts-expect-error check if this is valid for deep equal check
        account.cosmosResources !== updatedRaw.cosmosResources) {
        next.cosmosResources = (0, account_1.fromCosmosResourcesRaw)(updatedRaw.cosmosResources);
        changed = true;
    }
    if (updatedRaw.algorandResources &&
        // @ts-expect-error check if this is valid for deep equal check
        account.algorandResources !== updatedRaw.algorandResources) {
        next.algorandResources = (0, account_1.fromAlgorandResourcesRaw)(updatedRaw.algorandResources);
        changed = true;
    }
    if (updatedRaw.bitcoinResources &&
        shouldRefreshBitcoinResources(updatedRaw, account)) {
        next.bitcoinResources = (0, account_1.fromBitcoinResourcesRaw)(updatedRaw.bitcoinResources);
        changed = true;
    }
    if (updatedRaw.polkadotResources &&
        // @ts-expect-error check if this is valid for deep equal check
        account.polkadotResources !== updatedRaw.polkadotResources) {
        next.polkadotResources = (0, account_1.fromPolkadotResourcesRaw)(updatedRaw.polkadotResources);
        changed = true;
    }
    if (updatedRaw.tezosResources &&
        account.tezosResources !== updatedRaw.tezosResources) {
        next.tezosResources = (0, account_1.fromTezosResourcesRaw)(updatedRaw.tezosResources);
        changed = true;
    }
    if (updatedRaw.elrondResources &&
        account.elrondResources !== updatedRaw.elrondResources) {
        next.elrondResources = (0, account_1.fromElrondResourcesRaw)(updatedRaw.elrondResources);
        changed = true;
    }
    if (updatedRaw.cryptoOrgResources &&
        // @ts-expect-error types don't overlap ¯\_(ツ)_/¯
        account.cryptoOrgResources !== updatedRaw.cryptoOrgResources) {
        next.cryptoOrgResources = (0, account_1.fromCryptoOrgResourcesRaw)(updatedRaw.cryptoOrgResources);
        changed = true;
    }
    var nfts = (_a = updatedRaw === null || updatedRaw === void 0 ? void 0 : updatedRaw.nfts) === null || _a === void 0 ? void 0 : _a.map(account_1.fromNFTRaw);
    if (!updatedRaw.nfts && account.nfts) {
        delete next.nfts;
        changed = true;
    }
    else if (!(0, isEqual_1["default"])(account.nfts, nfts)) {
        next.nfts = nfts;
        changed = true;
    }
    if (!changed)
        return account; // nothing changed at all
    return next;
}
exports.patchAccount = patchAccount;
function patchSubAccount(account, updatedRaw) {
    var _a;
    // id can change after a sync typically if changing the version or filling more info. in that case we consider all changes.
    if (!account ||
        account.id !== updatedRaw.id ||
        account.parentId !== updatedRaw.parentId) {
        return (0, account_1.fromSubAccountRaw)(updatedRaw);
    }
    var operations = patchOperations(account.operations, updatedRaw.operations, updatedRaw.id, undefined);
    var pendingOperations = patchOperations(account.pendingOperations, updatedRaw.pendingOperations, updatedRaw.id, undefined);
    // $FlowFixMe destructing union type?
    var next = __assign({}, account);
    var changed = false;
    if (account.operationsCount !== updatedRaw.operationsCount &&
        updatedRaw.operationsCount) {
        next.operationsCount = updatedRaw.operationsCount;
        changed = true;
    }
    if (updatedRaw.creationDate &&
        updatedRaw.creationDate !== account.creationDate.toISOString()) {
        next.creationDate = new Date(updatedRaw.creationDate);
        changed = true;
    }
    if (account.operations !== operations) {
        next.operations = operations;
        changed = true;
    }
    if (account.pendingOperations !== pendingOperations) {
        next.pendingOperations = pendingOperations;
        changed = true;
    }
    if (updatedRaw.balance !== account.balance.toString()) {
        next.balance = new bignumber_js_1.BigNumber(updatedRaw.balance);
        changed = true;
    }
    if (next.type === "TokenAccount" &&
        account.type === "TokenAccount" &&
        updatedRaw.type === "TokenAccountRaw") {
        if (updatedRaw.spendableBalance !== account.spendableBalance.toString()) {
            next.spendableBalance = new bignumber_js_1.BigNumber(updatedRaw.spendableBalance || updatedRaw.balance);
            changed = true;
        }
        if (updatedRaw.compoundBalance !== ((_a = account.compoundBalance) === null || _a === void 0 ? void 0 : _a.toString())) {
            next.compoundBalance = updatedRaw.compoundBalance
                ? new bignumber_js_1.BigNumber(updatedRaw.compoundBalance)
                : undefined;
            changed = true;
        }
        if (updatedRaw.approvals &&
            !(0, isEqual_1["default"])(updatedRaw.approvals, account.approvals)) {
            next.approvals = updatedRaw.approvals;
            changed = true;
        }
    }
    var balanceHistoryCache = updatedRaw.balanceHistoryCache;
    if (balanceHistoryCache) {
        if (shouldRefreshBalanceHistoryCache(balanceHistoryCache, account)) {
            next.balanceHistoryCache = balanceHistoryCache;
            changed = true;
        }
    }
    if (!changed)
        return account; // nothing changed at all
    return next;
}
exports.patchSubAccount = patchSubAccount;
function patchOperations(operations, updated, accountId, subAccounts) {
    return minimalOperationsBuilderSync(operations, updated.slice(0).reverse(), function (raw) { return (0, account_1.fromOperationRaw)(raw, accountId, subAccounts); });
}
exports.patchOperations = patchOperations;
function findExistingOp(ops, op) {
    return ops.find(function (o) { return o.id === op.id; });
}
// This is one step of the logic of minimalOperationsBuilder
// it implements an heuristic to skip prematurely the operations loop
// as soon as we find an existing operation that matches newOp
function stepBuilder(state, newOp, i) {
    var existingOp = findExistingOp(state.existingOps, newOp);
    if (existingOp && !state.immutableOpCmpDoneOnce) {
        // an Operation is supposedly immutable.
        if (existingOp.blockHeight !== newOp.blockHeight) {
            // except for blockHeight that can temporarily be null
            state.operations.push(newOp);
            return;
        }
        else {
            state.immutableOpCmpDoneOnce = true;
            // we still check the first existing op we meet...
            if (!(0, jsHelpers_1.sameOp)(existingOp, newOp)) {
                // this implement a failsafe in case an op changes (when we fix bugs)
                // trade-off: in such case, we assume all existingOps are to trash
                (0, consoleWarnExpectToEqual_1["default"])(newOp, existingOp, "op mismatch. doing a full clear cache.");
                state.existingOps = [];
                state.operations.push(newOp);
                return;
            }
        }
    }
    if (existingOp) {
        // as soon as we've found a first matching op in old op list,
        var j = state.existingOps.indexOf(existingOp);
        var rest = state.existingOps.slice(j);
        if (rest.length > i + 1) {
            // if libcore happen to have less ops that what we had,
            // we actually need to continue because we don't know where hole will be,
            // but we can keep existingOp
            state.operations.push(existingOp);
        }
        else {
            // otherwise we stop the libcore iteration and continue with previous data
            // and we're done on the iteration
            if (state.operations.length === 0 && j === 0) {
                // special case: we preserve the operations array as much as possible
                state.operations = state.existingOps;
            }
            else {
                state.operations = state.operations.concat(rest);
            }
            state.finished = true;
            return;
        }
    }
    else {
        // otherwise it's a new op
        state.operations.push(newOp);
    }
}
//# sourceMappingURL=reconciliation.js.map